<template>
    <div class="header">
        <div class="h_content">
            <div class="h_c_logo">
                <img src="../../assets/images/logo.png" width="76" height="80" alt="">
            </div>
            <ul class="h_c_nav">
                <li
                    v-for="(item,index) in title"
                    :class="activeNum === index? 'active': ''"
                    :key="index">
                    <router-link :to=item.path>{{ item.name }}</router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "headindex",
        computed:{
            activeNum(){
                return this.$store.state.memu.active_menu
            }
        },
        watch:{
            '$route'(to){
                let path = to.path
                switch (path) {
                    case '/':
                        this.changeMenu(0)
                        break
                    case '/steward':
                        this.changeMenu(1)
                        break
                    case '/company':
                        this.changeMenu(2)
                        break
                    case '/information':
                        this.changeMenu(3)
                        break
                    case '/legislation':
                        this.changeMenu(4)
                        break
                    case '/project':
                        this.changeMenu(5)
                        break
                    case '/contact':
                        this.changeMenu(6)
                        break
                }
            }
        },
        data(){
            return {
                title:[
                    {name: '首页', path: '/'},
                    {name: '环保管家服务', path: '/steward'},
                    {name: '公司介绍', path: '/company'},
                    {name: '信息公开', path: '/information'},
                    {name: '法律法规', path: '/legislation'},
                    {name: '工程案例', path: '/project'},
                    {name: '联系我们', path: '/contact'},
                ]
            }
        },
        mounted(){
        },
        methods:{
            // handleClick(val){
            //     // console.log(val)
            //     this.$store.commit({
            //         type: 'setState',
            //         num: val
            //     })
            // },
            changeMenu(val){
                this.$store.commit({
                    type: 'setState',
                    num: val
                })
                window.sessionStorage.setItem('currentMenu', val)
            }
        }
    }
</script>

<style scoped>
    .header{
        width: 100%;
        height: 120px;
    }
    .h_content{
        width: 1100px;
        height: 100%;
        margin: 0 auto;
    }
    .h_c_logo{
        float: left;
        width: 76px;
        height: 80px;
        margin-top: 18px;
    }
    .h_c_nav{
        float: left;
        position: relative;
        left: 238px;
        top: 50%;
        transform: translateY(-50%);

    }
    .h_c_nav li{
        float: left;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
    }
    .h_c_nav li a{
        display: block;
        width: 100%;
        height: 100%;
        color: #333;
    }
    .h_c_nav li+li{
        margin-left: 60px;
    }
    .h_c_nav li.active a{
        color: #00B76B;
    }
</style>
